import React from "react";
import { Button } from "@mui/material";
import { ReactComponent as NoData } from "../../images/no-data.svg";

function NoDataFound({ onNewClick, btnName, heading, noDataInfo }) {
  return (
    <div className="no_data_found">
      <div className="no_data_found_info">
        <NoData />
        <h2>{heading}</h2>
        <p>{noDataInfo}</p>
        {btnName !== undefined && btnName !== "" && (
        <Button
          type="button"
          className="sav_btn bonus_btn"
          onClick={onNewClick}
        >
          <img
            src="/images/add-circle-wh.svg"
            alt="add"
            className="hidden max-[700px]:block"
          />
          <span className="max-[700px]:hidden">{btnName}</span>
        </Button>
        )}
      </div>
    </div>
  );
}

export default NoDataFound;
